import { render, staticRenderFns } from "./verbaleSP.vue?vue&type=template&id=8571a2c0"
import script from "./verbaleSP.vue?vue&type=script&lang=js"
export * from "./verbaleSP.vue?vue&type=script&lang=js"
import style0 from "./verbaleSP.vue?vue&type=style&index=0&id=8571a2c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports